module.exports = __webpack_public_path__ + "img/s.65ac298e.svg";